import { Theme, createTheme } from "@mui/material";

// @TODO: Fix colors and other mui components style
export const muiDarkTheme: Theme = createTheme({
  palette: {
    mode: "dark",
    text: {
      primary: "#D0D0D0",
      secondary: "#303030",
    },
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-sortIcon": {
            color: "#d0d0d0",
            opacity: "1 !important",
            visibility: "visible",
          },

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "800",
          },
          "& .MuiDataGrid-root": {
            fontFamily: "Honeywell Sans Web",
          },
          "& .MuiDataGrid-cell": {
            fontFamily: "Honeywell Sans Web",
          },
          "& .MuiDataGrid-columnHeaders": {
            fontFamily: "Honeywell Sans Web",
          },
          "& .MuiDataGrid-cellCheckbox": {
            "& .Mui-disabled": {
              "& svg": {
                color: "#333333 !important",
              },
            },
          },
        },
        footerContainer: {
          "&.MuiDataGrid-footerContainer": {
            justifyContent: "center",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#272727",
          color: "#D0D0D0",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#606060",
          padding: "0",
          marginRight: "0.5rem",
          "&.Mui-checked": {
            color: "#64c3ff !important",
          },
          "& .MuiSvgIcon-root": {
            backgroundColor: "inherit",
            border: "none",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          // @TODO: Change style once @forge/common tooltip theme fixed
          backgroundColor: "#272727",
          color: "#f0f0f0",
          borderRadius: ".2rem",
          padding: ".7rem",
          fontSize: ".875rem",
          ".MuiTooltip-arrow::before": {
            //pseudo-element for the arrow
            backgroundColor: "#272727",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          height: "2rem",
          fontSize: "0.875rem",
          gap: "0.5rem",
        },
        listbox: {
          fontSize: "0.7rem",
          paddingTop: "0px",
          paddingBottom: "0px",
          backgroundColor: "#272727",
        },
        root: {
          "& .MuiOutlinedInput-root": {
            padding: "0px",
            paddingRight: "5px",
            background: "#272727",
          },
          "& ..MuiAutocomplete-tag": {
            margin: "0px",
            height: "2rem",
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#f0f0f0",
            fontWeight: "normal !important",
          },
          "& .MuiAutocomplete-input::placeholder": {
            color: "#f0f0f0 !important",
            fontWeigth: "300",
          },
          "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
            height: "2rem", // Set the desired height
          },
          "& .MuiAutocomplete-listbox ul li": {
            fontSize: "2rem",
            background: "#ffffff",
          },
        },
        endAdornment: {
          // up/down chevron icon
          button: {
            filter: "invert(1)",
            marginLeft: "1rem",
          },
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: "#D0D0D0",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        deleteIcon: {
          color: "#606060",
          "&:hover": {
            color: "#808080",
          },
        },
      },
    },
  },
} as any);
